import { runInAction, toJS } from 'mobx';
import { Request, Response } from '../../system/utilities/network.js';
import langstore from '../../system/i18n/translator.js';


const init = async function(_token,welcomeMessage){

  let loadingKey = 'appinit';
  let token = this.userToken;
  let upgraded = await this.appUpgrade();
  if(_token){ token = _token; }
  if(upgraded === true){ token = false; }

  this.loadingAdd(loadingKey);

  if(token){
    // carico risorse
    await Promise.all([
      this.updateComunicazioni(),
      this.updateCapigruppo(),
      this.updateNumeratori(),
      this.updateStatiOrdine(),
      this.updateStatiReclamo(),
      this.updateLanguages(),
      this.updateEventiOrdini(),
      this.updateMenu(),
      this.updateAutorizzazioni(),
      this.updateEnabledEmails(),
      this.getInfoUtente(),
      this.updateTipologieMessaggi(),
      this.messageListUnread()
    ]);

    let menu = this.menuLoad();

    // attivo processi ping
    this.startPings();

    // al login language è aggiornato in base alle info del profilo; altrimenti default IT (todo prendere default da API)

    let changed = await this.languageChange(this.language);

    if(welcomeMessage){
      this.notificationAdd(`${langstore.t("user_welcome","Bentornato")} ${welcomeMessage}`,'userformlogin');
    }   

  }

  else{

    // this.languages
    let loaded = await this.updateLanguages();
    let activeLanguages = this.languages;

    /*
      Settaggio lingua di default
      Assume che lingua segnalata nel config (tipicamente "it") esista sempre
    */
    let languageTemp = this.config.languages.languageDefault;

    /*
      Cerca lingua di sistema;
      Se non è "it", lingua default diventa "en", ma solo se "en" esiste nelle lingue supportate
    */
    let languageSystem = navigator.language.split("-");
    languageSystem = languageSystem[0];
    if(languageSystem != "it"){
      for (var i = 0; i < activeLanguages.length; i++) {
        if ("en" === activeLanguages[i].iso){
          languageTemp = activeLanguages[i].iso;
        }
      }
    }

    /*
      Se lingua di sistem esiste nella lista lingue, scelgo quella
      Sovrascrivo lingua default
    */
    for (var i = 0; i < activeLanguages.length; i++) {
      if (languageSystem === activeLanguages[i].iso){
        languageTemp = activeLanguages[i].iso;
      }
    }

    /*
      Se c'è una lingua in cache ed esiste nella lista lingue, scelgo quella
      Sovrascrive lingua sistema
    */
    if(this.language){
      for (var i = 0; i < activeLanguages.length; i++) {
        if (this.language === activeLanguages[i].iso){
          languageTemp = activeLanguages[i].iso;
        }
      }      
    }

    /*
      Cambio lingua ed avvio app
    */
    let changed = await this.languageChange(languageTemp);
    if(welcomeMessage){
      this.notificationAdd(langstore.t("user_welcome","Bentornato" + " " + welcomeMessage),'userformlogin');
    }   

  }

  runInAction(()=>{
    this.appReady = true; 
    this.loadingRemove(loadingKey);        
  });  

  // this.routeReload(); // serve?
}


export {init}